import type { AuthUsersResp } from '@/lib/api';

interface Props {
  user: AuthUsersResp | null;
}

const sexMap: Record<number, string> = {
  1: '男',
  2: '女',
  3: '保密'
};

const ProfileOverview = ({ user }: Props) => {
  const profileRows = [
    { label: '暱稱', value: user?.nickname || '-' },
    { label: '電子郵箱', value: user?.email || '-' },
    { label: '性別', value: user?.userSex ? sexMap[user.userSex] || '保密' : '-' },
    { label: '生日', value: user?.userAge || '-' },
    { label: '備註', value: user?.remark || '-' }
  ];

  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 sm:p-7 shadow-[0_14px_35px_-28px_rgba(15,23,42,0.45)]">
      <header className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-xl font-bold text-slate-900">個人資訊</h3>
          <p className="text-sm text-slate-500 mt-1">此處顯示當前帳號綁定的個人資料與會員身分。</p>
        </div>
        <div className="hidden sm:flex items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm text-slate-600">
          <i className="ri-id-card-line text-base text-sky-600" />
          帳戶資料
        </div>
      </header>

      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {profileRows.map((row) => (
          <article key={row.label} className="rounded-2xl border border-slate-100 bg-slate-50/70 px-4 py-3">
            <p className="text-xs uppercase tracking-wider text-slate-400">{row.label}</p>
            <p className="mt-1 text-sm font-medium text-slate-700 break-all">{row.value}</p>
          </article>
        ))}
      </div>

      <div className={`mt-5 grid gap-3 ${Number(user?.availableAmount || 0) > 0 ? 'sm:grid-cols-3' : 'sm:grid-cols-2'}`}>
        <article className="rounded-2xl border border-emerald-100 bg-emerald-50 px-4 py-3">
          <p className="text-xs text-emerald-600">會員狀態</p>
          <p className="mt-1 text-sm font-semibold text-emerald-700">{user?.member ? '已開通會員' : '一般用戶'}</p>
        </article>
        <article className="rounded-2xl border border-violet-100 bg-violet-50 px-4 py-3">
          <p className="text-xs text-violet-600">會員方案</p>
          <p className="mt-1 text-sm font-semibold text-violet-700">{user?.memberPlanName || '-'}</p>
        </article>
        {Number(user?.availableAmount || 0) > 0 ? (
          <article className="rounded-2xl border border-sky-100 bg-sky-50 px-4 py-3">
            <p className="text-xs text-sky-600">可用餘額</p>
            <p className="mt-1 text-sm font-semibold text-sky-700">${Number(user?.availableAmount || 0).toFixed(2)}</p>
          </article>
        ) : null}
      </div>
    </section>
  );
};

export default ProfileOverview;
